import React from 'react';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import {Box, Text, VerticalDivider} from '../../../../styled';
import {JiraIssueContainer} from './styled';

const Snippet = ({ item }:any) => {
  const { snippet, att, date, reporterName, projectName } = item;
  const itemStatus = [
    projectName,
    reporterName && <span>Reported by {reporterName}</span>,
    date
  ].filter(s => s);
  return (
    <>
      <Box
        marginBottom="20px"
        marginTop="10px"
      >
        <Text>
          {snippet}
        </Text>
      </Box>
      <FileAttachments files={att} />
      <JiraIssueContainer className="date">
        {itemStatus.map((s, i) => (
          <React.Fragment key={i}>
            {s}
            {(i < itemStatus.length - 1) && <VerticalDivider />}
          </React.Fragment>
        ))}
      </JiraIssueContainer>
    </>
  )
}

export default Snippet;